import tagularModule from 'js/store/helpers/tagular'

let link, button, metaDescription, currentURL, title

//
// Get page url
////
const getPageURL = () => {
  return encodeURI(window.location.href)
}

//
// Get page title
////
const getTitle = () => {
  return encodeURI(window.document.title.replace('| Bankrate.com', ''))
}

//
// Get page meta
////
const getMeta = (name, content) => {
  content = content === null ? 'content' : content
  let metaElm = document.querySelector("meta[name='" + name + "']")
  return (metaElm && metaElm.getAttribute(content)) || ''
}

//
// Prep page share
////
const prepShare = element => {
  button = element

  currentURL = getPageURL()
  title = getTitle()

  link = (button && button.getAttribute('href')) || ''
  link = decodeURI(link)

  link = link.replace('[URL]', currentURL)
  link = link.replace('[TITLE]', title)
  link = link.replace('[SOURCE]', window.location.host)
  link = link.replace('[MEDIA]', getMeta('twitter:image', 'content'))

  if (document.querySelector('.pull-quote__copy')) {
    let quote = document.querySelector('.pull-quote__copy').innerHTML
    link = link.replace('[QUOTE]', quote)
  }

  // We previously decoded, twitter cannot handle a raw pipe
  link = link.replace('|', encodeURI('|'))
}

//
// Share functionality
////
const sharePage = (shareButton, event, index) => {
  event.preventDefault()

  const strWindowFeatures =
    'menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,width=500,height=500,top=0'

  prepShare(shareButton)

  button = shareButton

  const windowProps =
    button &&
    button.dataset &&
    button.dataset.newWindow &&
    button.dataset.newWindow === 'false'
      ? null
      : strWindowFeatures

  const shareWindow = window.open(link, 'Share', windowProps)

  const socialMediaType = button.dataset.socialType

  try {
    shareWindow.focus()
  } catch (error) {
    window.location = link
  }

  trackClickEvent(socialMediaType, index)
}

//
// Email functionality
////
const emailPage = (event, index) => {
  event.preventDefault()

  metaDescription = getMeta('description', 'content')
  currentURL = getPageURL()
  title = getTitle()

  window.location =
    'mailto:?subject=' +
    title +
    '&body=' +
    metaDescription +
    '%0D%0A' +
    '%0D%0A' +
    currentURL

  let socialMediaType = 'email'

  trackClickEvent(socialMediaType, index)
}

//
// Click tracking
////
const trackClickEvent = (socialMediaType, index) => {
  const webElement = {
    location: 'social modal',
    position: `${index}`,
    elementType: 'button',
    text: `${socialMediaType}`,
    htmlId: 'social-share',
    name: 'social share buttons'
  }

  const actionOutcome = 'social share'
  const outboundUrl = ''
  const correlationId = ''

  tagularModule.elementClicked(
    webElement,
    actionOutcome,
    outboundUrl,
    correlationId,
    'redventures.usertracking.v3.ElementClicked'
  )

  window.dataLayer = window.dataLayer || []

  window.dataLayer.push({
    dL_navHeading: socialMediaType,
    dL_position: 'left sidebar',
    event: 'e_navSocial'
  })
}

//
// Create click event
////
const createClickEvents = (element, index) => {
  const shareButton = element.querySelector('[data-share-button]')
  const isEmail = shareButton.hasAttribute('data-social-email')

  if (element.contains(shareButton)) {
    shareButton.addEventListener('click', event => {
      isEmail ? emailPage(event, index) : sharePage(shareButton, event, index)
    })
  }
}

//
// Bind click events to elelemtns
////
const bindClickEvents = selector => {
  const elements = document.querySelectorAll(selector)

  if (elements.length > 0) {
    elements.forEach((element, index) => {
      createClickEvents(element, index)
    })
  }
}

const init = () => {
  bindClickEvents('[data-share-button-container]')
}

init()
